<template>
  <div :class="['poster-subscribe', { 'hide-from-medium': visibility === SUBSCRIBE_VISIBILITY.MOBILE }]">
    <wptv-icon
      name="abonnement"
      height="45px"
      width="45px"
      aria-hidden="true"
      class="abonnement-icon"
      data-wptv="abonnement-icon" />
  </div>
</template>

<script>
import { WptvIcon } from '../../icon'
import WptvPosterConfig from '../poster.config'

export default {
  name: 'PosterSubscribe',
  components: {
    WptvIcon
  },
  props: {
    visibility: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      SUBSCRIBE_VISIBILITY: WptvPosterConfig.SUBSCRIBE_VISIBILITY
    }
  }
}
</script>

<style scoped lang="scss">
  .poster-subscribe {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
  }
</style>
